import { Injectable } from '@angular/core';

@Injectable({
  providedIn: "root"
})
export class MenuParametrage {
  toggled = false;

  menus = [
    {
      title: "Control Panel",
      type: "header",
      permission: "for_all"
    },

    {
      title: "Organisation",
      icon: "fa fa-globe",
      active: "",
      type: "dropdown",
      permission: "parametrage_organisation",
      submenus: [
        {
          title: "Monnaie",
          Url: "/parametrage/currency",
          active: "",
          permission: "parametrage_monnaie"
        },
        {
          title: "Pays",
          Url: "/parametrage/country",
          active: "",
          permission: "parametrage_pays"
        },
        {
          title: "Réseau",
          Url: "/parametrage/network",
          active: "",
          permission: "parametrage_reseau"
        },
        {
          title: "Ville",
          Url: "/parametrage/city",
          active: "",
          permission: "parametrage_ville"
        },
        {
          title: "Agence",
          Url: "/parametrage/bank",
          active: "",
          permission: "parametrage_agence"
        },
        {
          title: "Direction",
          Url: "/parametrage/direction",
          active: "",
          permission: "parametrage_direction"
        },
        {
          title: "Département",
          Url: "/parametrage/departement",
          active: "",
          permission: "parametrage_departement"
        },
        {
          title: "Membre CSC",
          Url: "/parametrage/membre-comite",
          active: "",
          permission: "parametrage_membreComite"
        }
      ]
    },

    {
      title: "Métier",
      icon: "fa fa-suitcase",
      active: "",
      type: "dropdown",
      permission: "parametrage_metier",
      submenus: [
        {
          title: "Type de crédit",
          Url: "/parametrage/type-credit",
          active: "",
          permission: "parametrage_typeCredit"
        },
        {
          title: "Forme juridique",
          Url: "/parametrage/legal-form",
          active: "",
          permission: "parametrage_formeJuridique"
        },
        {
          title: "Secteur d'activité",
          Url: "/parametrage/activity-area",
          active: "",
          permission: "parametrage_secteurActivite"
        },
        {
          title: "Assurance",
          Url: "/parametrage/assurance",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Année",
          Url: "/parametrage/annee",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Férié",
          Url: "/parametrage/ferie",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Type de congés",
          Url: "/parametrage/type-conges",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Statut dossier",
          Url: "/parametrage/statut-dossier",
          active: "",
          permission: "parametrage"
        },

        {
          title: "Paramètres généraux",
          Url: "/parametrage/parametre-general",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Paramètres scoring",
          Url: "/parametrage/parametre-scoring",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Marché",
          Url: "/parametrage/marche",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Fournisseur agréé",
          Url: "/parametrage/fournisseur-agree",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Nature garanties",
          Url: "/parametrage/garantie/nature-garanties",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Types de champs de garantie",
          Url: "/parametrage/garantie/champ-form-garanties",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Types documents garanties",
          Url: "/parametrage/garantie/types-documents-garanties",
          active: "",
          permission: "parametrage"
        },

        {
          title: "Nature produit crm",
          Url: "/parametrage/produit-crm/nature-produit-crm",
          active: "",
          permission: "parametrage"
        },
        {
          title: "Types de champs de produit crm",
          Url: "/parametrage/produit-crm/champ-form-produit-crm",
          active: "",
          permission: "parametrage"
        }
      ]
    },

    {
      title: "Utilisateurs",
      icon: "fa fa-group",
      active: "",
      type: "dropdown",
      permission: "parametrage_utilisateur",
      submenus: [
        {
          title: "Permission",
          Url: "/parametrage/permission",
          active: "",
          permission: "parametrage_permission"
        },
        {
          title: "Profil",
          Url: "/parametrage/user-profile",
          active: "",
          permission: "parametrage_profile"
        },
        {
          title: "Utilisateur",
          Url: "/parametrage/user",
          active: "",
          permission: "parametrage_employe"
        }
      ]
    },

    {
      title: "Workflow",
      icon: "fa fa-gears",
      active: "",
      type: "dropdown",
      permission: "parametrage_workflow",
      submenus: [
        {
          title: "Workflow",
          Url: "/parametrage/workflow",
          active: "",
          permission: "parametrage_process"
        },
        {
          title: "Statut des dossiers",
          Url: "/parametrage/request-status",
          active: "",
          permission: "parametrage_statutDossier"
        },
        {
          title: "Formulaire",
          Url: "/parametrage/formulaire",
          active: "",
          permission: "parametrage_process"
        },
        {
          title: "Service",
          Url: "/parametrage/service-execution",
          active: "",
          permission: "parametrage_process"
        },
        {
          title: "Tâche",
          Url: "/parametrage/task",
          active: "",
          permission: "parametrage_tache"
        }
      ]
    },

    {
      title: "Appétence aux risques",
      icon: "fa fa-gears",
      active: "",
      type: "dropdown",
      permission: "parametrage_workflow",
      submenus: [
        {
          title: "Appétence",
          Url: "/parametrage/ligne-financement",
          active: "",
          permission: "parametrage_process"
        },
        {
          title: " Appétence marché ",
          Url: "/parametrage/ligne-financement-marche",
          active: "",
          permission: "parametrage_statutDossier"
        },
        {
          title: " Appétence secteur",
          Url: "/parametrage/ligne-financement-secteur",
          active: "",
          permission: "parametrage_process"
        },
        {
          title: " Appétence produit",
          Url: "/parametrage/ligne-financement-produit",
          active: "",
          permission: "parametrage_process"
        }
      ]
    },

    {
      title: "Classification employeur",
      Url: "/parametrage/classification-employeur",
      icon: "fa fa-institution",
      active: "",
      permission: "parametrage_employeur",
      type: "simple"
    },

    {
      title: "Employeur",
      Url: "/parametrage/employeur",
      icon: "fa fa-institution",
      active: "",
      permission: "parametrage_employeur",
      type: "simple"
    },

    {
      title: "Check-list",
      Url: "/parametrage/check-list-document",
      icon: "fa fa-check-square-o",
      active: "",
      permission: "parametrage_checkList",
      type: "simple"
    },

    /*{
        title: 'Check-list',
        icon: 'fa fa-check-square-o',
        active: '',
        type: 'dropdown',
        permission:'parametrage_checkList',
        submenus: [
          {
            title: 'Check-list corporate',
            Url:'/parametrage/check-list-corporate',
            active: '',
            permission:'parametrage_checkListCorporate'
          },
          {
            title: 'Check-list particulier',
            Url:'/parametrage/check-list-particulier',
            active: '',
            permission:'parametrage_checkListParticulier'
          },
          {
            title: 'Check-list professionnel',
            Url:'/parametrage/check-list-professionnel',
            active: '',
            permission:'parametrage_checkListProfessionnel'
          },
          {
            title: 'Check-list product program',
            Url:'/parametrage/check-list-product-program',
            active: '',
            permission:'product_program'
          }
        ]
      },*/

    {
      title: "Sla",
      icon: "fa fa-dot-circle-o",
      active: "",
      type: "dropdown",
      permission: "parametrage_objectif",
      submenus: [
        {
          title: "Type de crédit par profil",
          Url: "/parametrage/objectif-type-credit-by-profil",
          active: "",
          permission: "parametrage_objectifTypeCreditParProfil"
        }
      ]
    },

    {
      title: "Smtp",
      Url: "/parametrage/smtp-config",
      icon: "fa fa-cog",
      active: "",
      permission: "parametrage_smtp",
      type: "simple"
    },

    {
      title: "Rule",
      Url: "/parametrage/rule-engine",
      icon: "fa fa-cog",
      active: "",
      permission: "parametrage_smtp",
      type: "simple"
    }
  ];

  constructor() {}

  toggle() {
    this.toggled = !this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }

  getMenuList() {
    return this.menus;
  }
}